export enum MigrationStatus {
  Pending = 'Pending',
  InProgress = 'InProgress',
  Query = 'Query',
  InApproval = 'InApproval',
  Complete = 'Complete',
}

export const MigrationStatuses = Object.values(MigrationStatus);
export const MigrationStatusesBeingMigrated = [
  MigrationStatus.InProgress,
  MigrationStatus.Pending,
  MigrationStatus.Query,
];
